import Vue from 'vue'
import Vuex from 'vuex'
import { decode } from 'jsonwebtoken'
import Cookies from 'js-cookie'

import actions from './actions'

const token = Cookies.get('auth_token')

const getExpireIn = token => {
  if (!token) return null

  const jwt = decode(token)

  return jwt ? jwt.exp : 0
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: null,
    email: '',
    avatar: '',
    accessToken: token,
    expireIn: getExpireIn(token),
    loading: false,
    profile: null,
    loginResponse: {
      code: 0,
      message: '',
    },
    confirmpass: {
      link: '',
      token: '',
    },
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
    LOGIN(state, { token, profile = {} }) {
      state.accessToken = token
      state.profile = profile
      state.expireIn = getExpireIn(token)

      Cookies.set('auth_token', token)
    },
    LOGOUT(state) {
      state.accessToken = null
      state.expireIn = null
      state.profile = null
      state.id = null
      state.email = null
      state.name = null
      state.role = null

      Cookies.remove('auth_token')
      Cookies.remove('vendor_id')
    },
    CLEAR_LOGIN(state) {
      Object.assign(state, {
        loginResponse: {
          code: 0,
          message: '',
        },
      })
    },
  },
  actions,
  getters: {
    user: state => state,
    loginStatusCode: state => state.loginResponse.code,
    expireIn: state => getExpireIn(state.accessToken),

    authorized: (state) => {
      return !!state.accessToken
    },
  },
}
